import type { HTMLAttributes, ReactNode } from 'react';
import { UiLegacy } from '@silvertours/front-legacy-shared';
import { Badge, InfoIcon, StyledTooltip } from './TooltipBadge.styles';

type TooltipBadgeProps = {
  badgeText: string;
  tooltipTitle: string;
  tooltipText: string;
  tooltipLabel?: string;
  onHover?: () => void;
  icon?: ReactNode;
} & Pick<HTMLAttributes<HTMLDivElement>, 'className'>;

const TooltipBadge = ({
  badgeText,
  tooltipTitle,
  tooltipText,
  tooltipLabel,
  onHover,
  icon,
  className,
}: TooltipBadgeProps) => (
  <Badge className={className}>
    {icon}
    {badgeText}
    {!icon && (
      <StyledTooltip
        content={<UiLegacy.Markup content={tooltipText} />}
        title={tooltipTitle}
        width="wide"
        trigger={<InfoIcon onMouseEnter={onHover} />}
        aria-label={tooltipLabel}
      />
    )}
  </Badge>
);

export { TooltipBadge };
